if (!customElements.get('olivers-market-schedule')) {
  class OliversMarketSchedule extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-market-schedule-list]');
      this.limit = Math.max(1, Number(this.dataset.limit || 4));
      this.marketLink = this.dataset.marketLink || '';
      this.orderLink = this.dataset.orderLink || '';

      try {
        const dataNode = this.querySelector('[data-market-locations]');
        this.locations = JSON.parse(dataNode?.textContent || '[]');
      } catch (error) {
        this.locations = [];
        console.error('Markttermine konnten nicht gelesen werden.', error);
      }

      this.render();
    }

    render() {
      const availability = window.OliversPickupAvailability;
      if (!this.list) return;

      if (!availability) {
        window.requestAnimationFrame(() => this.render());
        return;
      }

      const activeLocations = this.locations.filter(location => location.active === true);
      this.updateLocationCount(activeLocations.length);

      const markets = activeLocations
        .map(location => {
          const date = availability.availableDates(location, { limit: 1 })[0];
          return date ? { ...location, date } : null;
        })
        .filter(Boolean)
        .sort((first, second) => {
          return first.date.localeCompare(second.date)
            || Number(first.sortOrder || 999) - Number(second.sortOrder || 999)
            || String(first.name || '').localeCompare(String(second.name || ''), 'de-CH');
        })
        .slice(0, this.limit);

      if (markets.length === 0) {
        this.renderStatus(this.dataset.emptyText || 'Aktuell sind keine Markttermine verfügbar.');
        return;
      }

      const fragment = document.createDocumentFragment();
      markets.forEach(market => fragment.append(this.createRow(market, availability)));
      this.list.replaceChildren(fragment);
    }

    updateLocationCount(count) {
      const section = this.closest('.olivers-market-schedule');
      const countNode = section?.querySelector('[data-market-location-count]');
      if (countNode) countNode.textContent = String(count);
    }

    renderStatus(message) {
      const status = document.createElement('p');
      status.className = 'olivers-market-schedule__status';
      status.textContent = message;
      this.list.replaceChildren(status);
    }

    createRow(market, availability) {
      const row = document.createElement(this.orderLink ? 'a' : 'div');
      row.className = 'olivers-market-schedule__row';
      if (this.orderLink) {
        const destination = new URL(this.orderLink, window.location.origin);
        destination.searchParams.set('pickup_market', market.handle);
        row.href = destination.href;
      }

      const date = this.createDateBlock(market.date, availability);

      const marketDetails = document.createElement('span');
      marketDetails.className = 'olivers-market-schedule__market';

      const name = document.createElement('strong');
      name.textContent = market.name || '';
      marketDetails.append(name);

      if (market.hours) {
        const hours = document.createElement('small');
        hours.textContent = market.hours;
        marketDetails.append(hours);
      }

      const arrow = document.createElement('span');
      arrow.className = 'olivers-market-schedule__row-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';

      row.append(date, marketDetails, arrow);
      return row;
    }

    createDateBlock(value, availability) {
      const date = document.createElement('span');
      date.className = 'olivers-market-schedule__date';

      const parts = new Intl.DateTimeFormat('de-CH', {
        timeZone: 'UTC',
        weekday: 'short',
        day: '2-digit',
        month: 'short'
      }).formatToParts(availability.parseDate(value));
      const getPart = type => (parts.find(part => part.type === type)?.value || '').replace(/[.,]/g, '');

      const weekday = document.createElement('span');
      weekday.className = 'olivers-market-schedule__date-weekday';
      weekday.textContent = getPart('weekday');

      const day = document.createElement('span');
      day.className = 'olivers-market-schedule__date-day';
      day.textContent = getPart('day');

      const month = document.createElement('span');
      month.className = 'olivers-market-schedule__date-month';
      month.textContent = getPart('month');

      date.append(weekday, day, month);
      return date;
    }
  }

  customElements.define('olivers-market-schedule', OliversMarketSchedule);
}
